import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
//import Header from '../../components/Header'
//import Footer from '../../components/Footer'
import Sidebar from '../../components/Sidebar'
import InstallationForm from '../../components/InstallationForm'

class NewInstall extends Component {
  render() {
    const token = window.localStorage.getItem('user');
    if (token != null) {
    	return (
	      <div id="page-top">
				<Sidebar>
                <InstallationForm/>
                </Sidebar>
	      </div>
	

	    );
		}
		else {
    	return (
	      <div id="page-top">
				<Sidebar>
                <InstallationForm/>                
                </Sidebar>

	      </div>
	

	    );
    }
  }
}

export default NewInstall;